import { render, staticRenderFns } from "./index.vue?vue&type=template&id=93977c98&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93977c98",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/manage.pc.frontend-purchase-test/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('93977c98')) {
      api.createRecord('93977c98', component.options)
    } else {
      api.reload('93977c98', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=93977c98&scoped=true&", function () {
      api.rerender('93977c98', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/general/operation-center/supplier-deduction-manage/page/modules/table-list/index.vue"
export default component.exports